<template>
    <div>
        <nfcScanner :app_config="app_config" text="Scan NFC" action="jump_deck_on"></nfcScanner>

        <div v-if="discountCustomerFound">
            <div class="customer-details">
                <div class="nfc-customer-info">
                    <button class="close" @click="resetNFCCustomerDetails"></button>
                    <div class="d-flex flex-column flex-sm-row">
                        <div class="col-12 col-sm-6">
                            <div class="customer-details">
                                <h1 v-text="customerName"></h1>
                                <span class="session-num"><strong>Session: {{ latestSession }}</strong></span>

                                <div class="medical-list" v-if="hasMedicalConditions">
                                    <p><strong>Medical Conditions:</strong></p>
                                    <ul>
                                        <li :index="index" v-for="(condition, index) in medicalCondtions" :key="index" v-text="condition"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="activity d-flex align-items-center justify-content-center flex-column">
                                <div class="d-flex align-items-center justify-content-center flex-column">
                                    <h2>BUNGY</h2>
                                    <span :class="'status-big ' + activityStatus(bj)"></span>
                                </div>
                                <div class="d-flex align-items-center justify-content-center flex-column">
                                    <h2>SKYJUMP</h2>
                                    <span :class="'status-big ' + activityStatus(sj)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="discount-cards">
                <div class="customer-details-wrap">
                    <div class="activity-box">
                        <div class="d-grid">
                            <customerActivity 
                                ref="bj"
                                activity="Bungy" 
                                activityCode="bj" 
                                position="left"
                                :view_only="true"
                            ></customerActivity>
                            <customerActivity 
                                ref="sj"
                                activity="Skyjump" 
                                activityCode="sj" 
                                position="left"
                                :view_only="true" 
                            ></customerActivity>
                            <customerActivity 
                                ref="sw"
                                activity="Skywalk" 
                                activityCode="sw" 
                                position="left"
                                :view_only="true" 
                            ></customerActivity>
                            <customerActivity 
                                ref="tc"
                                activity="Tower climb" 
                                activityCode="tc" 
                                position="right"
                                :view_only="true" 
                            ></customerActivity>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nfcScanner from "./NFCScannerComponent.vue";
import customerActivity from "../DiscountCustomerActivity.vue";
import Swal from "../sweetAlert2/index";
import { mapState, mapActions } from 'vuex';

export default {
    props: ['app_config'],
    computed: {
        ...mapState([
            'discountCustomer',
            'discountCustomerFound',
            'customerLatestSession',
            'hasBJandSJ'
        ]),
        customerName() {
            if(!this.discountCustomer.firstname && !this.discountCustomer.lastname) {
                return this.discountCustomer.chinese_name;
            }
            
            return this.discountCustomer.firstname + " " + this.discountCustomer.lastname;
        },
        latestSession() {
            return this.customerLatestSession.session_number.substr(-4);
        },
        medicalCondtions() {
            let conditions = [];

            for (var key of Object.keys(this.customerLatestSession.unserializeMedical)) {
                if(this.customerLatestSession.unserializeMedical[key] != null && this.customerLatestSession.unserializeMedical[key] != 'None of the above') {
                    conditions.push(this.customerLatestSession.unserializeMedical[key]);
                }
            }

            return conditions;
        },
        hasMedicalConditions() {
            let hasCondition = false;

            for (var key of Object.keys(this.customerLatestSession.unserializeMedical)) {
                if(this.customerLatestSession.unserializeMedical[key] != null && this.customerLatestSession.unserializeMedical[key] != 'None of the above') {
                    hasCondition = true;
                }
            }

            return hasCondition;
        },
        bj() {
            return this.customerLatestSession.bjf ?? this.customerLatestSession.bjs ?? null;
        },
        sj() {
            return this.customerLatestSession.sjf ?? this.customerLatestSession.sjs ?? null;
        },
    },
    watch: {
        hasBJandSJ(value) {
            if(!value) {
                return;
            }

            //wait for the customer details to render before asking which activity to set to go
            this.$nextTick(() => {
                new Swal({
                    title: "Both activities subscribed.<br>Select one:",
                    text: "",
                    icon: "",
                    showCancelButton: true,
                    confirmButtonText: "Sky Jump",
                    cancelButtonText: "Bungy Jump",
                    reverseButtons: true,
                    allowOutsideClick: false,
                    showCloseButton: true,
                    customClass: {
                        confirmButton: "tandems-button",
                        cancelButton: "tandems-button",
                        title: 'switch-title',
                        popup: 'container switch-popup',
                        actions: 'switch-actions',
                        closeButton: 'switch-close',
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.selectJumpDeckOnActivity('SJ');
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        await this.selectJumpDeckOnActivity('BJ');
                    } else {
                        this.$store.state.hasBJandSJ = false;
                    }
                });
            });
        }
    },
    methods: {
        ...mapActions(['resetNFCCustomerDetails', 'selectJumpDeckOnActivity']),
        activityStatus(activity) {
            if (!activity) {
                return 'not-doing';
            }

            if ((activity.activity == 'SW' || activity.activity == 'TC') && !activity.group_number) {
                return 'not-assigned';
            }

            if(!activity.parent) {
                if (activity.is_uploading == 0) {
                    return 'waiting';
                }

                if (activity.is_uploading == 1 && activity.notification_sent == 0) {
                    return 'processing';
                }

                if (activity.is_uploading == 1 && activity.notification_sent == 1) {
                    return 'uploaded';
                }
            } else {
                if (activity.parent.is_uploading == 0) {
                    return 'waiting';
                }

                if (activity.parent.is_uploading == 1 && activity.parent.notification_sent == 0) {
                    return 'processing';
                }

                if (activity.parent.is_uploading == 1 && activity.parent.notification_sent == 1) {
                    return 'uploaded';
                }
            }
        }
    },
    components: {
        nfcScanner,
        customerActivity
    },
}
</script>
